module.exports = __webpack_public_path__ + "static/media/3-item-a.44bd4841.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/men/3-item-a.jpg
// module id = 1162
// module chunks = 33